import React, { useState } from "react";
import { Button } from "primereact/button";

const BlockUnblockForm = ({ onBlockOrUnblock, accountInfoData }) => {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("");

    const handleBlockOrUnblock = async (action) => {
        setloading(true);
        setloadingIcon("pi pi-spin pi-spinner");
        await onBlockOrUnblock(action);
        setloading(false);
        setloadingIcon("");
    };

    return (
        <div className="card Card__Round">
            <div className="Form__Header"></div>
            <form className="p-fluid p-mt-2">
                <div className="Down__Btn">
                    {accountInfoData.AccountStatus === "UN-BLOCK" ? (
                        <Button disabled={loading} icon={loadingIcon || ""} iconPos="right" label={"Block"} className="Btn__Dark" onClick={() => handleBlockOrUnblock("01")} />
                    ) : (
                        <Button disabled={loading} icon={loadingIcon || ""} iconPos="right" label={"Unblock"} className="Btn__Dark" onClick={() => handleBlockOrUnblock("02")} />
                    )}
                </div>
            </form>
        </div>
    );
};

export default BlockUnblockForm;
